export const dateComparator = (d1: Date, d2: Date) => {
  return d1 < d2 ? -1 : d1 > d2 ? 1 : 0
}
